<script setup lang="ts">
import { toRef, watch } from 'vue';
import { SearchableSelect } from '@/components/ui/searchable-select';
import { useProjectSelect } from '@/composables/useProjectSelect';

const props = withDefaults(
  defineProps<{
    modelValue?: number | string | null;
    customerId?: number | string | null;
    disabled?: boolean;
    placeholder?: string;
    pageSize?: number;
    class?: any;
  }>(),
  {
    pageSize: 500,
  }
);

const emit = defineEmits<{
  (e: 'update:modelValue', value: number | string | null): void;
  (e: 'change', project: any | null): void;
}>();

function onChangeValue(id: number | string | null) {
  const item =
    id != null ? projects.value.find((p: any) => p.id === id || String(p.id) === String(id)) : null;
  emit('change', item ?? null);
}

const customerIdRef = toRef(props, 'customerId');
const modelValueRef = toRef(props, 'modelValue');

const { projects, loading, hasMore, fetchProjects, loadMore, onSearch } = useProjectSelect({
  customerId: customerIdRef,
  selectedId: modelValueRef,
  pageSize: props.pageSize,
});

watch(
  customerIdRef,
  val => {
    if (val) fetchProjects();
  },
  { immediate: true }
);

defineExpose({
  projects,
  fetchProjects,
});
</script>

<template>
  <SearchableSelect
    :model-value="modelValue"
    :options="projects"
    :loading="loading"
    :remote-search="true"
    :has-more="hasMore"
    :disabled="disabled || !customerId"
    :placeholder="placeholder"
    :class="props.class"
    value-prop="id"
    label-prop="name"
    @update:model-value="emit('update:modelValue', $event)"
    @change="onChangeValue"
    @search-change="onSearch"
    @load-more="loadMore"
  />
</template>
